<template>
    <el-card>
        <div slot="header">
            <span class="top_title">采购单</span>
        </div>
        <div class="searchItem">
            <div class="search">
                <span class="searchtips">日期:</span>
                <el-date-picker
                    v-model="searchDate.dateRan"
                    type="daterange"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 230px"
                    :editable="false"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </div>
            <div class="search">
                <span class="searchtips">采购单:</span>
                <el-input v-model="searchDate.purid" placeholder="" style="width: 160px;"></el-input>
            </div>
            <div class="search">
                <span class="searchtips">供应商:</span>
                <el-select v-model="searchDate.slid" clearable style="width:160px">
                    <el-option v-for="item in supplyList" :key="item.id" :value="item.id" :label="item.label"></el-option>
                </el-select>
            </div>
            <div class="search">
                <span class="searchtips">仓库:</span>
                <el-select v-model="searchDate.wareid" clearable style="width:160px">
                    <el-option v-for="item in listWare" :key="item.id" :value="item.id" :label="item.label"></el-option>
                </el-select>
            </div>
            <div class="search" style="display:flex">
                <span class="searchtips">商品:</span>
                <SearchBox @changeSelect="changeSelect($event,'pids')"></SearchBox>
            </div>
            <div class="search" style="display:flex">
                <span class="searchtips">客户:</span>
                <SearchBox
                    :searchLabel="'customer'"
                    :showLabel="'cname'"
                    @changeSelect="changeSelect($event,'cid')"
                    :url="'/mobile/customer/listCustomer'"
                ></SearchBox>
            </div>
            <div class="search" style="display:flex">
                <span class="searchtips">经办人:</span>
                <SearchBox
                    :searchLabel="'query'"
                    @changeSelect="changeSelect($event,'eid')"
                    :url="'/mobile/employee/listEmployee'"
                ></SearchBox>
            </div>
            <div class="search">
                <span class="searchtips">备注:</span>
                <el-input v-model="searchDate.remark" placeholder="" style="width: 160px;"></el-input>
            </div>
            <div class="search">
                <el-button type="primary" icon="el-icon-search" @click="searchOrder()">查询</el-button>
            </div>
            <div class="search">
                <el-button
                    type="primary"
                    icon="el-icon-printer"
                    @click="print"
                    v-if="$common.checkWindowsEnv()"
                    >打印</el-button>
                <el-button
                    type="primary"
                    icon="el-icon-document"
                    @click="changePdf"
                >导出</el-button>
            </div>
        </div>
        <div style="display:flex;justify-content: flex-end;">
            <el-button split-button type="primary" @click="edit(0)" v-if="$common.hasLimits('materialOrderAdd')">新增</el-button>
        </div>
        <el-table
            :data="tableData"
            style="
                width: 100%;
                margin-top: 20px;
                margin-bottom: 20px;
            "
            border
            show-summary
            :summary-method="getSummaries"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column label="操作" width="200px" align="center">
                <template slot-scope="{row}">
                    <el-button type="text" v-if="row.state==0||row.state==1" v-show="$common.hasLimits('materialOrderPass')" @click="editOrderPass(row.id,1)">通过</el-button>
                    <el-button type="text" v-if="row.state==2" v-show="$common.hasLimits('materialOrderPass')" @click="editOrderPass(row.id,0)">反审核</el-button>
                    <el-button type="text" v-if="row.state==2||row.state==3" v-show="$common.hasLimits('materialOrderIn')" @click="enterStore(row.id)">入库</el-button>
                    <el-button type="text" v-if="$common.hasLimits('materialOrderDetailEdit')" @click="edit(row.id)">编辑</el-button>
                    <el-button type="text" v-if="$common.hasLimits('materialOrderDetailDelete')" @click="del(row.id)">删除</el-button>
                </template>
            </el-table-column>
            <template v-for="(col, index) in cols">
                <template v-if="col.show">
                    <el-table-column :key="index" :prop="col.prop" :label="col.label" :width="col.width" :align="col.align">
                        <template #header v-if="col.column">
                            {{col.label}}
                            <el-button circle icon="el-icon-top" size="mini" v-if="searchDate.column==col.column&&searchDate.order==true" type="primary" @click="setSort(col.column,true)"></el-button>
                            <el-button circle icon="el-icon-top" size="mini" v-else @click="setSort(col.column,true)"></el-button>
                            <el-button circle icon="el-icon-bottom" size="mini" v-if="searchDate.column==col.column&&searchDate.order==false" type="primary" @click="setSort(col.column,false)"></el-button>
                            <el-button circle icon="el-icon-bottom" size="mini" v-else @click="setSort(col.column,false)"></el-button>
                        </template>
                    </el-table-column>
                </template>
            </template>
        </el-table>
            <el-pagination
            style="text-align: right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 50, 120, 250]"
            :page-size="cp_pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :pager-count="5"
        >
        </el-pagination>
        <el-dialog
            :visible.sync="mOrderEnterDialog"
            title="采购单入库"
            width="90%"
        >
            <div style="display:flex;line-height:40px">
                <div>采购单号:{{enterNum}}</div>
                <div style="padding-left:10px">供应商:{{enterSupply}}</div>
            </div>
            
            <div class="search" style="margin-bottom:20px">
                <span class="searchtips">采购仓库:</span>
                <el-select v-model="enterWid" style="width:160px">
                    <el-option v-for="item in listWare" :key="item.id" :value="item.id" :label="item.label"></el-option>
                </el-select>
            </div>
            <SPTable ref="spt" :cols='cols2' :structure="structure" @returnData="saveEnter" :productModel="false" :wareHouseModel="false" :mproductModel="true" :autoAdd="true"></SPTable>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" 
                    @click="submit()">保存入库</el-button
                >
                <el-button @click="mOrderEnterDialog = false"
                    >关闭</el-button
                >
            </div>
        </el-dialog>
        <ReportOrder ref="roder"></ReportOrder>
        <edit-share ref="share"></edit-share>
    </el-card>
</template>

<script>
import SPTable from '../../components/table-column/supertable';
import ReportOrder from '../../components/printshare/reportorder.vue';
import editShare from '../../components/printshare/edit_share';
export default {
    components:{
        SPTable,
        ReportOrder,
        editShare,
    },
    data(){
        return{
            searchDate: {
                dateRan: "",
                purid:"",
                remark:"",
                slid:"",
                wareid:'',
                pids:'',
                cid:'',
                column:'',
				order:'',
                eid:'',
            },
            mOrderEnterDialog:false,
            pickerOptions: {shortcuts:this.$common.initPickerOptions()},
            cols:[
                {
                prop: 'number',
                label: '采购单号',
                width: 160,
                show: true,
                align:'left',
                column:'number',
            },{
                prop: 'money',
                label: '开单金额(元)',
                width: 180,
                show: true,
                align:'left',
                column:'money',
            },{
                prop: 'paySum',
                label: '支付金额(元)',
                width: 180,
                show: true,
                align:'left',
                column:'paySum',
            },{
                prop: 'freeSum',
                label: '优惠金额(元)',
                width: 180,
                show: true,
                align:'left',
                column:'freeSum',
            },{
                prop: 'supplyName',
                label: '供应商',
                width: 170,
                show: true,
                align:'left',
                column:'supply',
            },{
                prop: 'wname',
                label: '入库仓库',
                width: 100,
                show: true,
                align:'left',
            },{
                prop: 'ename',
                label: '经办人',
                width: 100,
                show: true,
                align:'left',
            },{
                prop: 'stateName',
                label: '状态',
                width: '',
                show: true,
                align:'left',
            },{
                prop: 'cname',
                label: '客户',
                width: '',
                show: true,
                align:'left',
            },{
                prop: 'pname',
                label: '商品',
                width: '',
                show: true,
                align:'left',
            },{
                prop: 'remark',
                label: '备注',
                width: '',
                show: true,
                align:'left',
            },{
                prop: 'date',
                label: '创建日期',
                width: 180,
                show: true,
                align:'left',
                column:'date',
            }],
            cols2:[
                {
                    prop: "name",
                    label: "产品",
                    edit:'',
                    type: "",
                    width: 240,
                },
                {
                    prop: "price",
                    label: "开价单价(元)",
                    edit:'',
                    type: "",
                    width: 130,
                },
                {
                    prop: "realprice",
                    label: "现金单价(元)",
                    edit:'priceEdit',
                    type: "priceEdit",
                    width: 130,
                },
                {
                    prop: "count",
                    label: "数量",
                    edit:'countEdit',
                    type: "unknowNumCLEdit",
                    width: 130,
                    maxValue:'maxValue'
                },
                {
                    prop: "enternum",
                    label: "已入库",
                    edit:'',
                    type: "",
                    width: 130,
                },
                {
                    prop: "ordernum",
                    label: "订购数量",
                    edit:'',
                    type: "",
                    width: 130,
                },
                {
                    prop: "tprice",
                    label: "总价(元)",
                    edit:'',
                    type: "tpriceEdit",
                    width: 130,
                    cal1:'price',
                    cal2:'ordernum',
                },
                
            ],
            tableData:[],
            total:0,
            currentPage:1,
            cp_pagesize:20,
            supplyList:[],
            listWare:[],
            nowSearch:{
                limit:20,
                page:1,
            },
            enterNum:'',
            enterSupply:'',
            enterId:'',
            enterWid:'',
            multipleSelection:[],
        }
    },
    created(){
        this.$api.listSupply().then(res=>{
            if(res.data.code==1){
                res.data.data.data.forEach(e => {
                    let obj = {
                        id:e.id,
                        label:"["+e.number+"]"+e.name,
                    }
                    this.supplyList.push(obj);
                });
            }
        })
        this.$api.mListWare().then(res=>{
            if(res.data.code==1){
                res.data.data.data.forEach(e => {
                    let obj = {
                        id:e.id,
                        label:e.name,
                    }
                    this.listWare.push(obj);
                });
            }
        })
        this.getInfo();
    },
    methods: {
        getSummaries(){
            return [,'合计',,this.moneySum,this.paySum,this.freeSum]
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        print(){
            if(this.multipleSelection.length>0){
                let array = [];
                this.multipleSelection.forEach(e=>{
                    array.push(e.id);
                })
                this.$nextTick(()=>{
                    this.$refs.roder.extraOpen(14,array);
                })
            }else{
                this.$common.error("没有选择采购单");
            }
        },
        changePdf(){
            if(this.multipleSelection.length>0){
                let array = [];
                this.multipleSelection.forEach(e=>{
                    array.push(e.id);
                })
                this.$nextTick(()=>{
                    this.$refs.share.openList(array,14);
                })
            }else{
                this.$common.error("没有选择采购单");
            }
        },
        structure(){
            let obj = {
                id:0,
                pid: '',
                spid:'',
                price: 0,
                count: 0,
                name:'',
                maxValue:0,
                realprice:0,
                enternum:'',
                ordernum:'',
                tprice:'',
                inter:'',
                countEdit:false,
                priceEdit:false,
                moneySum:0,
                paySum:0,
                freeSum:0,
            }
            return obj;
        },
        submit(){
            this.$refs.spt.getData();
        },
        setSort(column,order){
            if(this.searchDate.column==column&&this.searchDate.order==order){
                this.searchDate.column = '';
                this.searchDate.order = '';
            }else{
                this.searchDate.column = column;
                this.searchDate.order = order;
            }
            this.sortTime();
        },
        sortTime(){
            if(this.searchDate.column){
                this.nowSearch.column = this.searchDate.column;
                this.nowSearch.order = this.searchDate.order?'asc':'desc';
            }else{
                delete this.nowSearch.column;
                delete this.nowSearch.order;
            }
            this.getInfo();
        },
        saveEnter(formData){
            let obj = {
                id:this.enterId,
                date:this.$common.format(new Date()),
                mwid:this.enterWid,
            }
            let data = [];
            formData.forEach(e=>{
                if(e.count>0){
                    let ob = {
                        id:e.id,
                        in:e.count,
                        present:e.realprice,
                    }
                    data.push(ob);
                }
            })
            if(data.length>0){
                obj.data = JSON.stringify(data);
                this.$api.orderInRecord(obj).then(res=>{
                    if(res.data.code==1){
                        this.$notify({
                            title: "采购单入库",
                            message: "入库成功",
                            type: "success",
                            duration: 1000,
                        });
                        this.mOrderEnterDialog = false;
                        this.getInfo();
                    }
                })
            }
        },
        enterStore(id){
            this.$api.mOrderDetail({id:id}).then(res=>{
                if(res.data.code==1){
                    let info = res.data.data;
                    this.enterId = id;
                    this.enterNum = info.number;
                    this.enterSupply ="["+info.supplyNumber+"]"+ info.supplyName;
                    this.enterWid = info.wid;
                    this.mOrderEnterDialog = true;
                    this.$nextTick(()=>{
                        this.$refs.spt.setData(info.detail,(o,e)=>{
                            o.id = e.id,
                            o.pid = e.mid;
                            o.spid = e.msid;
                            o.price = e.price;
                            o.realprice = e.present;
                            o.enternum = e.complete;
                            o.ordernum = e.amount;
                            o.name = e.mnumber +' ' +e.mname+"_"+e.mspec1+"_"+e.mspec2;
                            o.tprice = e.money;
                            o.unit = e.packing;
                            o.inter = e.inter;
                            o.maxValue = e.amount-e.complete;
                        })
                    })
                }
            })
        },
        searchOrder(){
            this.currentPage = 1;
            this.nowSearch = {
                limit:this.cp_pagesize,
                page:1,
            }
            if(this.searchDate.dateRan&&this.searchDate.dateRan.length>=2){
                this.nowSearch.start = this.searchDate.dateRan[0];
                this.nowSearch.end = this.searchDate.dateRan[1];
            }
            if(this.searchDate.purid.length>0){
                this.nowSearch.number = this.searchDate.purid;
            }
            if(this.searchDate.slid>0){
                this.nowSearch.supply = this.searchDate.slid;
            }
            if(this.searchDate.wareid>0){
                this.nowSearch.wid = this.searchDate.wareid;
            }
            if(this.searchDate.pids.length>0){
                this.nowSearch.pid = this.searchDate.pids;
            }
            if(this.searchDate.cid.length>0){
                this.nowSearch.cid = this.searchDate.cid;
            }
            if(this.searchDate.eid.length>0){
                this.nowSearch.eid = this.searchDate.eid;
            }
            if(this.searchDate.remark.length>0){
                this.nowSearch.remark = this.searchDate.remark;
            }
            this.sortTime();
        },
        getInfo(){
            this.$api.mListOrder(this.nowSearch).then(res=>{
                if(res.data.code==1){
                    this.tableData = res.data.data.data;
                    this.total = res.data.data.total;
                    this.moneySum = res.data.data.moneySum;
                    this.paySum = res.data.data.paySum;
                    this.freeSum = res.data.data.freeSum;
                }
            })
        },
        handleSizeChange(e){
            this.cp_pagesize = e;
            this.searchOrder();
        },
        handleCurrentChange(e){
            this.currentPage = e;
            this.nowSearch.page = e;
            this.getInfo();
        },
        changeSelect(e,key){
            this.searchDate[key] = e;
        },
        edit(id){
            if(!id){
                id = 0;
            }
            this.$router.push({ 
                path: "/purchaseAdd",
                query:{id:id},
            })
        },
        del(id){
            if(!id){
                return;
            }
            this.$api.deleteOrder({deleteId:id}).then(res=>{
                if(res.data.code==1){
                    if(this.tableData.length==1&&this.currentPage>1){
                        this.currentPage = 1;
                    }
                    this.$notify({
                        title: "删除采购单",
                        message: "删除成功",
                        type: "success",
                        duration: 1000,
                    });
                    this.getInfo();
                }
            })
        },
        editOrderPass(id,val){
            if(!id){
                return;
            }
            let str = '审核';
            if(val==0){
                str = '反'+str;
            }
            this.$api.editOrderPass({id:id,pass:val}).then(res=>{
                if(res.data.code==1){
                    this.$notify({
                        title: str+"采购单",
                        message: str+"成功",
                        type: "success",
                        duration: 1000,
                    });
                    this.getInfo();
                }
            })
        }
    }
}
</script>